import React, { FC } from 'react';
import classNames from 'classnames';

interface IconProps {
  className?: string;
  width?: number;
  height?: number;
}

export const IconOrganization: FC<React.PropsWithChildren<IconProps>> = ({ className, width = 32, height = 32 }) => (
  <svg className={classNames([className])} width={width} height={height} viewBox={`0 0 22 22`} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99707 6H5.99707V8H7.99707V6Z" fill="currentColor" />
    <path d="M5.99707 10H7.99707V12H5.99707V10Z" fill="currentColor" />
    <path d="M11.9971 6H9.99707V8H11.9971V6Z" fill="currentColor" />
    <path d="M9.99707 10H11.9971V12H9.99707V10Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.99707 5C1.99707 3.34315 3.34022 2 4.99707 2H12.9971C14.6539 2 15.9971 3.34315 15.9971 5V10H19C20.6569 10 22 11.3431
       22 13V22H1.99707V5ZM7.99707 20H9.99707V16H7.99707V20ZM11.9971 20V14H5.99707V20H3.99707V5C3.99707 4.44772 4.44479 4 4.99707
        4H12.9971C13.5494 4 13.9971 4.44772 13.9971 5V20H11.9971ZM19 12H16V20H20V13C20 12.4477 19.5523 12 19 12Z"
      fill="currentColor"
    />
  </svg>
);
